import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Icon } from 'shared/components';
import InfoTab from 'modules/appointmentInfo/components/InfoTab';
import DropdownMenu from 'modules/appointmentInfo/components/DropdownMenu';

import theme from './AppointmentInfoSidebar.scss';
import GroupNavigation from '../GroupNavigation';


const propTypes = {
  canCloseAppointment: PropTypes.bool,
  isNeedToShowBackButton: PropTypes.bool,
  hideAppointmentInfo: PropTypes.func,
  rtl: PropTypes.bool,
};

const defaultProps = {
  canCloseAppointment: false,
  isNeedToShowBackButton: false,
  hideAppointmentInfo: undefined,
  rtl: false,
};

const AppointmentInfoSidebar = ({
  canCloseAppointment,
  isNeedToShowBackButton,
  hideAppointmentInfo,
  intl,
  rtl,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div className={ theme.leftContainer }>
        <If condition={ isNeedToShowBackButton }>
          <button
            data-testid="patient-info-sidebar-back-button"
            aria-label={ intl.formatMessage({
              id: 'General.Back',
              defaultMessage: '** Back',
            }) }
            className={ theme.backButton }
            onClick={ hideAppointmentInfo }
          >
            <Icon
              className={ theme.leftContainer }
              name={ rtl ? 'arrow-right' : 'arrow-left' }
            />
          </button>
        </If>
      </div>

      <div className={ theme.centerContainer }>
        <h2 role="alert" aria-live="polite" tabIndex={ 0 }>
          { intl.formatMessage({ id: 'schedule.patientInfoTab.appointmentInfo', defaultMessage: '** Appointment Info' }) }
        </h2>
      </div>
      <div className={ theme.rightContainer }>
        { canCloseAppointment && <DropdownMenu /> }
      </div>
    </div>

    <GroupNavigation />
    <InfoTab />

  </div>
);

AppointmentInfoSidebar.propTypes = propTypes;
AppointmentInfoSidebar.defaultProps = defaultProps;

export default injectIntl(AppointmentInfoSidebar);
